import { DataContext } from 'App';
import { FC } from 'react';
import { Footer } from '.';

export const FooterContainer: FC = () => (
	<DataContext.Consumer>
		{(dataContext): JSX.Element => <Footer footerText={dataContext.textKeys.global.footer} />}
	</DataContext.Consumer>
);
